(() => {
  if (window.fmpInitialized) return;
  window.fmpInitialized = true;
  let opener;
  const isDesktop = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function openContact(trigger, mode, selectedNumber) {
    const dialog = document.getElementById('fmp-contact-dialog');
    if (!dialog) return;
    const isPhone = mode === 'Bellen';
    const desktopPhone = isPhone && isDesktop();
    const model = trigger.dataset.fmpModelName;
    dialog.querySelector('[data-fmp-contact-caption]').textContent = desktopPhone ? 'Bel ons op een van deze nummers. Je kunt het nummer ook kopiëren.' : isPhone ? 'Kies je vestiging om direct te bellen.' : 'Stuur een bericht naar de winkel van je keuze.';
    dialog.querySelectorAll('[data-fmp-branch]').forEach(row => {
      const link = row.querySelector('[data-fmp-number]');
      link.href = isPhone ? `tel:+${link.dataset.fmpNumber}` : `https://wa.me/${link.dataset.fmpNumber}${model ? '?text=' + encodeURIComponent(`Hoi, ik wil graag een reparatie voor mijn ${model} bespreken. Wanneer kan ik langskomen?`) : ''}`;
      if (isPhone) link.removeAttribute('target'); else link.target = '_blank';
      link.rel = 'noopener';
      link.hidden = desktopPhone;
      row.querySelector('[data-fmp-phone-label]').hidden = !isPhone;
      row.querySelector('[data-fmp-call-option]').hidden = !desktopPhone;
      row.querySelector('[data-fmp-copy-status]').textContent = '';
      row.dataset.selected = String(row.dataset.fmpBranch === selectedNumber);
    });
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    if (desktopPhone && selectedNumber) {
      const selected = Array.from(dialog.querySelectorAll('[data-fmp-branch]')).find(row => row.dataset.fmpBranch === selectedNumber);
      selected?.querySelector('.fmp-call-number').focus();
    }
  }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-fmp-contact]');
    const directPhone = event.target.closest('.fmp a[href^="tel:"]');
    const dialog = document.getElementById('fmp-contact-dialog');
    if (trigger && dialog) {
      event.preventDefault();
      openContact(trigger, trigger.dataset.fmpContact);
      return;
    }
    // Desktop should reveal a number, without launching a Windows calling app.
    if (directPhone && isDesktop() && dialog) {
      event.preventDefault();
      openContact(directPhone, 'Bellen', directPhone.getAttribute('href').replace(/[^0-9]/g, ''));
      return;
    }
    const copy = event.target.closest('[data-fmp-copy]');
    if (copy) {
      const status = copy.closest('[data-fmp-branch]').querySelector('[data-fmp-copy-status]');
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(copy.dataset.fmpCopy);
        status.textContent = 'Nummer gekopieerd';
      } catch {
        status.textContent = 'Selecteer het nummer om het zelf te kopiëren.';
        copy.closest('[data-fmp-branch]').querySelector('.fmp-call-number').focus();
      }
      return;
    }
    if (event.target.closest('[data-fmp-close]') && dialog) { dialog.close(); opener?.focus(); }
    if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) { dialog.close(); opener?.focus(); } }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-fmp-search]')) {
      const normalize = value => value.toLocaleLowerCase('nl').replace(/\b(samsung|galaxy|apple)\b/g, '').replace(/\s+/g, '');
      const query = normalize(event.target.value);
      let count = 0;
      document.querySelectorAll('[data-fmp-model]').forEach(model => { model.hidden = !normalize(model.dataset.fmpModel).includes(query); if (!model.hidden) count++; });
      event.target.parentElement.querySelector('.fmp-search-result').textContent = query ? (count ? `${count} modellen gevonden` : 'Geen model gevonden. Vraag je prijs aan bij onze winkel.') : '';
    }
    const form = event.target.closest('[data-fmp-appointment]');
    if (form) form.querySelector('.fmp-whatsapp-review').hidden = true;
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-fmp-appointment]');
    if (form) form.querySelector('.fmp-whatsapp-review').hidden = true;
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-fmp-appointment]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const data = new FormData(form), branch = form.elements.branch.selectedOptions[0].textContent;
    const message = `Hoi ${branch}, ik wil graag een afspraak aanvragen.\nToestel: ${data.get('device').trim()}\nKlacht: ${data.get('problem').trim()}\nVoorkeur: ${data.get('preference').trim() || 'In overleg'}`;
    const review = form.querySelector('.fmp-whatsapp-review');
    review.querySelector('[data-fmp-message]').textContent = message;
    const link = review.querySelector('[data-fmp-send]');
    link.href = `https://wa.me/${data.get('branch')}?text=${encodeURIComponent(message)}`;
    review.hidden = false;
    link.focus();
  });
  document.addEventListener('shopify:block:select', event => {
    const model = event.target.closest('[data-fmp-model]');
    if (model) { model.hidden = false; model.open = true; }
  });
})();
